"use client";
import { jsx } from "react/jsx-runtime";
import { Drawer } from "@base-ui/react/drawer";
import { forwardRef } from "react";
const DrawerTrigger_DrawerTrigger = /*#__PURE__*/ forwardRef(function(props, ref) {
    return /*#__PURE__*/ jsx(Drawer.Trigger, {
        ref: ref,
        ...props
    });
});
export { DrawerTrigger_DrawerTrigger as DrawerTrigger };
